import React, { useContext, useState } from "react";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import ClaimDealModal from "./ClaimDealModal"; 

const EsDealCard = ({ deal, isPublic = true, claimStatus = null, onClaimed }) => {
  const { baseUrlForFile, setSelectedDealFromLandingPage } = useContext(AppContext);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const status = claimStatus?.toLowerCase();
  const isBlocked = ["pending", "approved", "complete"].includes(status);

  const claimLabel = isBlocked
    ? status === "pending"
      ? "Request Sent"
      : "Claimed"
    : status === "rejected"
    ? "Claim Again"
    : "Claim this deal";

  return (
    <>
      <Col lg={6} md={6} sm={12} key={deal.id}>
        <div className="estatica-deals__card">
          {/* Badge */}
          {deal.tag && (
            <span className="estatica-deals__badge">{deal.tag}</span>
          )}

          {/* Discount */}
          <p className="estatica-deals__discount">{deal.discount}</p>

          {/* Name & Desc */}
          <h4 className="estatica-deals__name">{deal.title}</h4>
          <p className="estatica-deals__desc">{deal.description}</p>

          {/* Buttons */}
          <div className="estatica-deals__btn-group">
                <button
              className="estatica-deals__btn-claim"
              disabled={isBlocked}
              onClick={() => {
                if (isPublic) {
                  navigate("/customer/login");
                } else {
                  setShowModal(true);
                }
              }}
            >
              {claimLabel}
            </button>
            {/* <button
              className="estatica-deals__btn-claim"
              onClick={() => {
                if (isPublic) {
                  navigate("/customer/login"); 
                } else {
                setShowModal(true); 
                }
              }}
            >
              Claim this deal
            </button> */}
            <button
              className="estatica-deals__btn-view"
              onClick={() => {
                navigate("/deal-details");
                setSelectedDealFromLandingPage(deal);
              }}
            >
              View details
            </button>
          </div>
        </div>
      </Col>

      {/* Modal - sirf dashboard pe show hoga (isPublic = false) */}
       {!isPublic && showModal && (
        <ClaimDealModal
          deal={deal}
          onClose={() => setShowModal(false)}
          onClaimed={onClaimed}
        />
      )}
    </>
  );
};

export default EsDealCard;